<template>
  <div>
    <b-modal
      size="sm"
      no-close-on-backdrop
      hide-footer
      :id="
        modal_id != ''
          ? `modalDataCertificate${modal_id}`
          : 'modalDataCertificate'
      "
      title="ASSINATURA"
      centered
    >
      <div class="row">
        <div class="col-md-12">
          <p class="certificate-information">
            Fazer download do arquivo para verificar em
          </p>
          <p class="certificate-information">
            <a
              href="https://verificador.iti.gov.br/verifier-2.10/"
              target="_blank"
              rel="noopener noreferrer"
              class="certificate-link-iti"
            >
              <i class="fas fa-link mr-2"></i>
              Verificador ITI
            </a>
          </p>
          <p class="certificate-information">
            (Instituto Nacional de Tecnologia da Informação)
          </p>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <v-btn small class="btn-save btn-block" @click="execute()">
            <i class="fas fa-download mr-1 mr-2 text-twenty"></i>
            BAIXAR PDF ASSINADO
          </v-btn>
        </div>
      </div>
    </b-modal>
    <v-btn
      class="btn-certified mt-1 mb-1"
      @click="openModalDataCertificate()"
      :small="small"
    >
      <i class="fas fa-paste mr-1 mr-2 text-twenty"></i>
      CERTIFICADO
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ButtonGenerateCertificate",

  props: {
    modal_id: { type: [String, Number], default: "" },
    small: { type: Boolean, default: false },
    data_base64: { type: String, default: "" },
  },

  methods: {
    openModalDataCertificate() {
      let { modal_id } = this;
      if (modal_id != "") {
        this.$bvModal.show(`modalDataCertificate${modal_id}`);
      } else {
        this.$bvModal.show("modalDataCertificate");
      }
    },

    execute() {
      let { data_base64 } = this;

      window.open(data_base64, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-data_base64 {
  color: #333;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;

  //   height: 300px;
  //   overflow-y: scroll;
}

.certificate-information {
  font-size: 12px;
  text-align: center;
}

.certificate-link-iti {
  font-size: 12px;
  background-color: blue;
  padding: 8px 36px;
  color: #fff;
  border-radius: 16px;
}

.certificate-link-iti:hover {
  text-decoration: none !important;
}
</style>
